import { configureStore } from '@reduxjs/toolkit';
import userReducer from './userSlice';
import zohoUserReducer from './zohoUserSlice';

export default configureStore({
    reducer: {
        user: userReducer,
        zohoUser: zohoUserReducer
    }
})